import { flatMap, has } from "lodash";
import { useReducer } from "react";
import { toast } from "react-hot-toast";
import api from "../../apis/axiosInterceptor";

interface Master {
  userRoleData: any;
  userCreateRoleData: object;
  unitData: object;
  siteUnitData: object;
  siteDocumentData: object;
  memberDocumentData: object;
  memberDataBySiteId: object;
  siteByIdData: object;
  projectTypesData: any;
  error: string;
  isImportSuccess: boolean;
  memberEditData: object;
  memberFilterData: object;
  developerSiteFilterData: object;
  editRoleUserData: any[];
}

const initialArgs: Master = {
  userRoleData: [],
  userCreateRoleData: {},
  unitData: {},
  siteUnitData: {},
  siteDocumentData: {},
  memberDocumentData: {},
  memberDataBySiteId: {},
  siteByIdData: {},
  projectTypesData: [],
  error: "",
  isImportSuccess: false,
  memberEditData: {},
  memberFilterData: {},
  developerSiteFilterData: {},
  editRoleUserData: [],
};

const reducer = (state: Master, action: Master) => {
  return { ...state, ...action };
};

const useSystemUserRole = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const getUserRole = async (
    page: string,
    listPerPage: string,
    searchValue: string,
    sort: string,
    order: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/role/get-all?page=${page}&pageSize=${listPerPage}&searchValue=${searchValue}&sort=${sort === undefined ? "" : sort}&order=${order === undefined ? "" : order}`,
      );
      //console.log("result => ", result);

      if (result.data.status) {
        setState({
          ...state,
          userRoleData: result.data.data[0],
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const getSiteUnit = async (
    siteId: any,
    page: string,
    listPerPage: string,
    searchValue: string,
    sort: string,
    order: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/site/unit/?site=${siteId}&page=${page}&pageSize=${listPerPage}&searchValue=${searchValue}&sort=${sort === undefined ? "" : sort}&order=${order === undefined ? "" : order}`,
        // `/api/site/unit/?page=${page}&pageSize=${pageSize}&searchValue=${searchValue}&sort=${sort}&order=${order}/66b2068f9ea3a824836d1058`,
      );

      if (result.data.status) {
        setState({
          ...state,
          siteUnitData: result.data.data[0],
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const getSiteDocument = async (siteId: any) => {
    try {
      const result: any = await api.get(
        `/api/site-document/type?type=project-site-documents&site=${siteId}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          siteDocumentData: result?.data?.data,
        });

        return true;
      } else {
        const errorStr = has(result?.data, "errors")
          ? Object(flatMap(result?.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const createUserRole = async (param: any) => {
    try {
      const result: any = await api.post("/api/role/create", param);

      if (result.data.status) {
        toast.success(result.data.message);
        setState({ ...state, userCreateRoleData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const getProjectSiteById = async (siteId: any) => {
    try {
      setState({
        ...state,
        siteByIdData: {},
      });
      const result: any = await api.get(`/api/site/${siteId}`);
      // `/api/site/${siteId}`,

      if (result.data.status) {
        setState({
          ...state,
          siteByIdData: result.data.data,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const uploadSiteDocument = async (siteDocument: any) => {
    console.log("siteDocumentsiteDocument", siteDocument);

    try {
      const result: any = await api.postForm(
        `/api/site-document`,
        siteDocument,
      );

      if (result.data.status) {
        toast.success(result.data.message);
        return { status: true, data: result.data.data };
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  //Update Project Site
  const updateProjectSite = async (
    projectSiteId: any,
    projectSiteData: any,
  ) => {
    const paramObj = {
      ...projectSiteData,
    };
    try {
      const { data } = await api.put(`/api/site/${projectSiteId}`, paramObj);

      if (data.status === true) {
        toast.success(data.message);
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      return false;
    }
  };

  //Update Unit API
  const updateUnit = async (unitId: any, unitData: any) => {
    const paramObj = {
      ...unitData,
    };
    console.log("paramObjUpdateUnit => ", paramObj);

    try {
      const { data } = await api.put(`/api/unit/${unitId}`, paramObj);

      if (data.status === true) {
        toast.success(data.message);
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      return false;
    }
  };

  const deleteSiteDocument = async (siteId: string) => {
    console.log("siteIdsiteId", siteId);
    try {
      const { data } = await api.delete(`/api/site-document/${siteId}`);

      if (data.status === true) {
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      return false;
    }
  };
  const deleteMemberDocument = async (mermberDocumentId: string) => {
    try {
      const { data } = await api.delete(
        `/api/member-document/${mermberDocumentId}`,
      );

      if (data.status === true) {
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      return false;
    }
  };

  const getProjectTypeList = async () => {
    try {
      const { data } = await api.get(`/api/setting/type?type=project-type`);

      if (data.status === true) {
        const filteredProjectTypesData = data?.data.map((item: any) => {
          return { ...item, id: item._id };
        });
        setState({ ...state, projectTypesData: filteredProjectTypesData });
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      return false;
    }
  };
  const getMemberBySite = async (
    page: string,
    pageSize: string,
    searchValue: string,
    sort: string,
    order: string,
    siteId: any,
  ) => {
    try {
      const result: any = await api.get(
        `/api/member?page=${page}&pageSize=${pageSize}&searchValue=${searchValue}&sort=${sort}&order=${order}&site=${siteId}`,
        // `/api/site/developer?developer=66b5aee1afe69e1bf080a8b1&page=${page}&pageSize=${pageSize}&searchValue=${searchValue}&sort=${sort}&order=${order}`,
      );
      // `/api/member?site=${siteId}&page=${page}&pageSize=${listPerPage}`,

      if (result.data.status) {
        setState({
          ...state,
          memberDataBySiteId: result.data.data[0].rows,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  const addMembersInUnits = async (paramObj: any) => {
    console.log(">> paramObj", paramObj);

    try {
      const result: any = await api.post(`/api/member`, paramObj);
      console.log("Create Project Site =>", result);

      if (result.data.status) {
        /* setState({
          ...state,
          siteByIdData: result.data.data,
        }); */
        toast.success(result?.data?.message);
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        //setState({ ...state, error: errorStr });
        toast.error(errorStr);
        return false;
      }
    } catch (error: any) {
      //setState({ ...state, error: error.message });
      toast.error(error.message);
      return false;
    }
  };

  //Edit Member Unit
  const getMemberById = async (memberId: string) => {
    try {
      const result: any = await api.get(`/api/member/${memberId}`);

      // console.log("result: ", result.data.data);

      if (result.data.status) {
        //setState({ ...state, memberEditData: result.data.data });
        return result.data.data;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        //setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      //setState({ ...state, error: error.message });
      return false;
    }
  };

  //Update Member
  const updateMember = async (memberId: string, param: any) => {
    const paramObj = {
      ...param,
    };
    console.log("paramObjUpdateMember => ", paramObj);

    try {
      const { data } = await api.put(`/api/member/${memberId}`, paramObj);

      if (data.status === true) {
        toast.success(data.message);
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      return false;
    }
  };

  //Member Document
  const getMemberDocument = async (memberId: string) => {
    try {
      const result: any = await api.get(
        `/api/member-document/type?type=member-documents&member=${memberId}`,
      );
      //console.log("result => ", result);

      if (result.data.status) {
        setState({
          ...state,
          memberDocumentData: result?.data?.data,
        });

        return true;
      } else {
        const errorStr = has(result?.data, "errors")
          ? Object(flatMap(result?.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };

  //Member Upload Document
  const uploadMemberDocument = async (memberDocument: any) => {
    console.log("Member Document", memberDocument);

    try {
      const result: any = await api.postForm(
        `/api/member-document`,
        memberDocument,
      );
      console.log("resultforMemberDocument => ", result);

      if (result.data.status) {
        toast.success(result.data.message);
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.response.data.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };

  /* Site Filter Api Start */
  const getMemberFilter = async (
    page: string,
    pageSize: string,
    searchValue: string,
    sort: string,
    order: string,
    developerId: string,
    siteId: string,
    projectTypeId: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/member/filter?page=${page}&pageSize=${pageSize}&order=${order}&searchValue=${searchValue}&sort=${sort}&developer=${developerId}&site=${siteId}&projectType=${projectTypeId}`,
      );
      console.log("resultforProjectSiteFilter => ", result);

      if (result.data.status) {
        setState({
          ...state,
          memberFilterData: result.data.data[0].rows,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  /* Site Filter Api End */

  /* Edit Role API Start */
  const editRoleUser = async (roleUserId: string) => {
    try {
      const result: any = await api.get(`/api/role-access/get/${roleUserId}`);

      // console.log("result: ", result.data.data);

      if (result.data.status) {
        setState({ ...state, editRoleUserData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  /* Edit Role API End */

  /* Update the RoleAccess API Start */
  const updateRoleUser = async (roleId: any, data: any) => {
    //const data = [...param];
    console.log("paramObj => ", data);

    try {
      const response = await api.put(`/api/role-access/update/${roleId}`, {
        data,
      });

      if (response.data.status === true) {
        toast.success(response.data.message);
        return true;
      }
    } catch (error) {
      console.info("error => ", error);
      return false;
    }
  };
  /* Update the RoleAccess API End */

  return {
    createUserRole,
    getUserRole,
    updateRoleUser,
    getSiteUnit,
    getProjectSiteById,
    getSiteDocument,
    uploadSiteDocument,
    updateProjectSite,
    updateUnit,
    deleteSiteDocument,
    deleteMemberDocument,
    getMemberBySite,
    getProjectTypeList,
    addMembersInUnits,
    getMemberById,
    updateMember,
    getMemberDocument,
    uploadMemberDocument,
    getMemberFilter,
    editRoleUser,
    ...state,
  };
};

export default useSystemUserRole;
